
var orig_allowInteraction = $.ui.dialog.prototype._allowInteraction;
$.ui.dialog.prototype._allowInteraction = function(event) {
    // address interaction issues with general iframes with the dialog
    if (event.target.ownerDocument != this.document[0]) {
        return true;
    }
    // address interaction issues with dialog window
    if ($(event.target).closest(".cke_dialog").length) {
        return true;
    }
    // address interaction issues with iframe based drop downs in IE
    if ($(event.target).closest(".cke").length) {
        return true;
    }
    return orig_allowInteraction.apply(this, arguments);
}

$(once('cm-wrap-tables', 'table')).wrap('<div class="table-wrapper"></div>');

// Toggle attribute
jQuery.fn.toggleAttr = function(attr, val) {
    var test = jQuery(this).attr(attr);
    if ( test ) {
        jQuery(this).removeAttr(attr);
    } else {
        jQuery(this).attr(attr, val);
    }
    return this;
};

// Toggle attribute value
jQuery.fn.toggleAttrVal = function(attr, val1, val2) {
    var test = jQuery(this).attr(attr);
    if ( test === val1) {
        jQuery(this).attr(attr, val2);
        return this;
    }
    if ( test === val2) {
        jQuery(this).attr(attr, val1);
        return this;
    }

    jQuery(this).attr(attr, val1);
    return this;
};

// Save, Share, Feedback

jQuery(document).click(function(e){
    let shareButton = jQuery('.share-button');
    if (shareButton.hasClass('open') && jQuery(e.target) !== shareButton) {
        shareButton.removeClass('open');
        shareButton.attr('aria-expanded', 'false');
        jQuery('.share-options').toggleAttrVal('aria-hidden', 'true', 'false');
    }
});

jQuery(once('cm-ssfmenu-focus', 'body')).on('keyup', '#save-share-feedback-wrapper input, #save-share-feedback-wrapper button, #save-share-feedback-wrapper a', function (e) {
    if(e.which == 9) {
        jQuery('.focused-new').removeClass('focused-new');
        jQuery(this).addClass('focused-new');
    }
});

jQuery(once('cm-ssfmenu-blur', 'body')).on('blur', '#save-share-feedback-wrapper input, #save-share-feedback-wrapper button, #save-share-feedback-wrapper a', function (e) {
    jQuery('.focused-new').removeClass('focused-new');
});

jQuery(once('cm-ssfmenu-click', 'body')).on('click', '#save-share-feedback-wrapper button', function (e) {
    e.preventDefault();
    e.stopPropagation();
    jQuery(this).toggleClass('open');
    if (jQuery(this).attr('aria-expanded') === "false") {
        jQuery(this).attr('aria-expanded', 'true');
        jQuery('.share-options').attr('aria-hidden', 'false');
    } else {
        jQuery(this).attr('aria-expanded', 'false');
        jQuery('.share-options').attr('aria-hidden', 'true');
    }
});

// Buttons
jQuery(document).on('focus', '.button', function (e) {
    jQuery(this).addClass('focused');
});
jQuery(document).on('blur', '.button', function (e) {
    jQuery(this).removeClass('focused');
});

// Main navigation
// Open mobile menu
jQuery(once('cm-btnmenu-click', 'body')).on('click', '.btn-menu', function (e) {
    e.preventDefault();
    jQuery('.header-menu-inner-wrap').toggleClass('nav-open');
    jQuery('.header-wrap').toggleClass('menu-open');
    jQuery('.menu-item-has-sub').removeClass('sub-menu-open');
    jQuery(this).toggleAttrVal('aria-expanded', 'true', 'false');
});

jQuery(document).on('focus', '.menu .menu-item', function (e) {
    jQuery(this).addClass('menu-item-has-focus');
});

jQuery(document).on('focusout', '.menu .menu-item', function (e) {
    jQuery(this).removeClass('menu-item-has-focus');
});

jQuery(once('cm-sub-menu-close', 'body')).on('click', '#close-sub-menu', function (e) {
    // debugger;
    e.preventDefault();
    var subMenu = jQuery(this).closest('.sub-menu');
    subMenu.attr('aria-hidden', 'true');
    subMenu.parent().removeClass('sub-menu-open');
    subMenu.prev().attr('aria-expanded', 'false');
    jQuery('ul.menu').removeClass('menu-child-sub-open');
    jQuery('body').removeClass('sub-menu-open');
});

// Sub menu dropdown in main nav
jQuery(once('cm-menu-click', 'body')).on('click', '.menu-lnk-has-sub', function (e) {
    e.preventDefault();
    if(jQuery(this).parent().hasClass('sub-menu-open')) {
        jQuery(this).parent().removeClass('sub-menu-open');
        jQuery(this).attr('aria-expanded', 'false');
        jQuery(this).parent().find('.sub-menu').attr('aria-hidden', 'true');
        jQuery('body').removeClass('sub-menu-open');
    } else {
        jQuery('.sub-menu-open').removeClass('sub-menu-open');
        jQuery('.sub-menu').attr('aria-hidden', 'true');
        jQuery('.menu-lnk-has-sub').attr('aria-expanded', 'false');
        jQuery(this).parent().addClass('sub-menu-open');
        jQuery(this).parent().parent().addClass('menu-child-sub-open');
        jQuery(this).attr('aria-expanded', 'true');
        jQuery(this).parent().find('.sub-menu').attr('aria-hidden', 'false');
        jQuery('body').addClass('sub-menu-open');
    }
});

jQuery('#user-login-form .form-item-pass').append('<button type="button" class="btn-pwd-view">View/Hide</button>');

jQuery(once('cm-pwd-show', 'body')).on('click', '.btn-pwd-view', function (e) {
    e.preventDefault();
    jQuery('#edit-pass').toggleAttrVal('type', 'password', 'text');
    jQuery(this).toggleClass('btn-pwd-hide');
});

// Video descriptions
jQuery(once('cm-toggle-videodesc', 'body')).on('click', '.video-desc-head', function (e) {
    e.preventDefault();
    let videoDescCont = jQuery(this).next();
    videoDescCont.slideToggle('fast');
    videoDescCont.toggleAttrVal('aria-hidden', 'true', 'false');
    jQuery(this).find('i').toggleClass('icon-minus');
    jQuery(this).find('i').toggleClass('icon-plus');
});
